import { tableConstantsFactory } from './tableConstantsFactory';
const formModalConstants = tableConstantsFactory('FORMMODAL');

// add in extra constants here.
formModalConstants.OPEN = 'FORMMODAL_OPEN';
formModalConstants.CLOSE = 'FORMMODAL_CLOSE';
formModalConstants.FORMAT_CHANGE = 'FORMMODAL_FORMAT_CHANGE';
formModalConstants.SET_EDITOR_CACHE_VALUE = 'FORMMODAL_SET_EDITOR_CACHE_VALUE';
formModalConstants.SET_EDITOR_CACHE_VALUE_FROM_DEFERRED = 'FORMMODAL_SET_EDITOR_CACHE_VALUE_FROM_DEFERRED';
export default formModalConstants;